module.exports = __webpack_public_path__ + "static/img/icon10.eba77d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon10.png
// module id = jzyy
// module chunks = 1